import * as R from 'ramda';

/**
 * Get an URL param
 *
 * @function
 * @return {string} url param
 */
var getParam = function getParam(param) {
  var match = RegExp("[?&]".concat(param, "=([^&]*)")).exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};

var getQueryStringDict = function getQueryStringDict() {
  var queryDict = {};
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var formQueryString = args ? args[0] : '';
  if (typeof window !== 'undefined') {
    var _window, _window$location, _locationSearch$subst;
    var locationSearch = formQueryString || ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.search);
    var queryString = (locationSearch === null || locationSearch === void 0 ? void 0 : (_locationSearch$subst = locationSearch.substring(1)) === null || _locationSearch$subst === void 0 ? void 0 : _locationSearch$subst.split('&')) || [''];
    for (var i = 0; i < queryString.length; i++) {
      var param = queryString[i].split('=');
      if (param.length === 2) {
        queryDict[param[0]] = decodeURIComponent(param[1].replace(/\+/g, ' '));
      }
    }
  }
  return queryDict;
};

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Module exports.
 * @public
 */
var parse_1 = parse;
var serialize_1 = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }
  var obj = {};
  var opt = options || {};
  var pairs = str.split(';');
  var dec = opt.decode || decode;
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=');

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }
    var key = pair.substring(0, index).trim();

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim();

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1);
      }
      obj[key] = tryDecode(val, dec);
    }
  }
  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;
  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }
  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }
  var value = enc(val);
  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }
  var str = name + '=' + value;
  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid');
    }
    str += '; Max-Age=' + Math.floor(maxAge);
  }
  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }
    str += '; Domain=' + opt.domain;
  }
  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }
    str += '; Path=' + opt.path;
  }
  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }
    str += '; Expires=' + opt.expires.toUTCString();
  }
  if (opt.httpOnly) {
    str += '; HttpOnly';
  }
  if (opt.secure) {
    str += '; Secure';
  }
  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }
  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}

function hasDocumentCookie() {
  // Can we get/set cookies on document.cookie?
  return (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && typeof document.cookie === 'string';
}
function parseCookies(cookies, options) {
  if (typeof cookies === 'string') {
    return parse_1(cookies, options);
  } else if (_typeof(cookies) === 'object' && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}
function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === 'undefined') {
    // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
  }
  return !doNotParse;
}
function readCookie(value, options) {
  if (options === void 0) {
    options = {};
  }
  var cleanValue = cleanupCookieValue(value);
  if (isParsingCookie(cleanValue, options.doNotParse)) {
    try {
      return JSON.parse(cleanValue);
    } catch (e) {
      // At least we tried
    }
  }
  // Ignore clean value if we failed the deserialization
  // It is not relevant anymore to trim those values
  return value;
}
function cleanupCookieValue(value) {
  // express prepend j: before serializing a cookie
  if (value && value[0] === 'j' && value[1] === ':') {
    return value.substr(2);
  }
  return value;
}

var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var Cookies = /** @class */function () {
  function Cookies(cookies, options) {
    var _this = this;
    this.changeListeners = [];
    this.HAS_DOCUMENT_COOKIE = false;
    this.cookies = parseCookies(cookies, options);
    new Promise(function () {
      _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
    })["catch"](function () {});
  }
  Cookies.prototype._updateBrowserValues = function (parseOptions) {
    if (!this.HAS_DOCUMENT_COOKIE) {
      return;
    }
    this.cookies = parse_1(document.cookie, parseOptions);
  };
  Cookies.prototype._emitChange = function (params) {
    for (var i = 0; i < this.changeListeners.length; ++i) {
      this.changeListeners[i](params);
    }
  };
  Cookies.prototype.get = function (name, options, parseOptions) {
    if (options === void 0) {
      options = {};
    }
    this._updateBrowserValues(parseOptions);
    return readCookie(this.cookies[name], options);
  };
  Cookies.prototype.getAll = function (options, parseOptions) {
    if (options === void 0) {
      options = {};
    }
    this._updateBrowserValues(parseOptions);
    var result = {};
    for (var name_1 in this.cookies) {
      result[name_1] = readCookie(this.cookies[name_1], options);
    }
    return result;
  };
  Cookies.prototype.set = function (name, value, options) {
    var _a;
    if (_typeof(value) === 'object') {
      value = JSON.stringify(value);
    }
    this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = serialize_1(name, value, options);
    }
    this._emitChange({
      name: name,
      value: value,
      options: options
    });
  };
  Cookies.prototype.remove = function (name, options) {
    var finalOptions = options = __assign(__assign({}, options), {
      expires: new Date(1970, 1, 1, 0, 0, 1),
      maxAge: 0
    });
    this.cookies = __assign({}, this.cookies);
    delete this.cookies[name];
    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = serialize_1(name, '', finalOptions);
    }
    this._emitChange({
      name: name,
      value: undefined,
      options: options
    });
  };
  Cookies.prototype.addChangeListener = function (callback) {
    this.changeListeners.push(callback);
  };
  Cookies.prototype.removeChangeListener = function (callback) {
    var idx = this.changeListeners.indexOf(callback);
    if (idx >= 0) {
      this.changeListeners.splice(idx, 1);
    }
  };
  return Cookies;
}();

var BGEA_SOURCE$1 = 'bgea_source';
var getSourceCookie = function getSourceCookie() {
  var cookies = new Cookies();
  var bgeaSource = cookies.get(BGEA_SOURCE$1);
  return bgeaSource || null;
};

var getSourceQueryString = function getSourceQueryString() {
  var sourceCode = '';
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var formQueryString = args ? args[0] : '';
  var queryStringDict = getQueryStringDict(formQueryString);
  Object.entries(queryStringDict).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if ((key === null || key === void 0 ? void 0 : key.toLocaleLowerCase()) === 'source') {
      sourceCode = value;
    }
  });
  return sourceCode;
};

var truncateString = function truncateString(str, len, delimiter, cap) {
  if (str && str.length > len) {
    var lengthTrim = str.substring(0, len - 1);
    var endCap = cap || '...';
    var delim = delimiter || ' ';
    return lengthTrim.substring(0, Math.min(lengthTrim.length, lengthTrim.lastIndexOf(delim))) + endCap;
  }
  return str;
};
var isCookieEnabled = typeof window !== 'undefined' ? navigator.cookieEnabled : true;
var isLocalStorageAvailable = function isLocalStorageAvailable() {
  var test = 'test';
  try {
    if (typeof window !== 'undefined') {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
    }
    return true;
  } catch (e) {
    return false;
  }
};

var breakpoints = {
  /**
   * @returns 599
   */
  forPhoneOnly: 599,
  /**
   * @returns 600
   */
  forTabletVerticalUp: 600,
  /**
   * @returns 899
   */
  forTabletVerticalDown: 899,
  /**
   * @returns 900
   */
  forTabletHorizontalUp: 900,
  /**
   * @returns 1199
   */
  forTabletHorizontalDown: 1199,
  /**
   * @returns 1200
   */
  forDesktopUp: 1200,
  /**
   * @returns 1799
   */
  forDesktopDown: 1799,
  /**
   * @returns 1800
   */
  forBigDesktopUp: 1800,
  /**
   * @returns 2649
   */
  forUltraWideDesktopDown: 2649,
  /**
   * @returns 2650
   */
  forUltraWideDesktopUp: 2650
};
var mediaQueries = {
  /**
   * @returns @media screen and (max-width: 599px)
   */
  forPhoneOnly: "@media screen and (max-width: ".concat(breakpoints.forPhoneOnly, "px)"),
  /**
   * @returns @media screen and (max-width: 600px)
   */
  forTabletVerticalUp: "@media screen and (min-width: ".concat(breakpoints.forTabletVerticalUp, "px)"),
  /**
   * @returns @media screen and (max-width: 899px)
   */
  forTabletVerticalDown: "@media screen and (max-width: ".concat(breakpoints.forTabletVerticalDown, "px)"),
  /**
   * @returns @media screen and (max-width: 900px)
   */
  forTabletHorizontalUp: "@media screen and (min-width: ".concat(breakpoints.forTabletHorizontalUp, "px)"),
  /**
   * @returns @media screen and (max-width: 1199px)
   */
  forTabletHorizontalDown: "@media screen and (max-width: ".concat(breakpoints.forTabletHorizontalDown, "px)"),
  /**
   * @returns @media screen and (max-width: 1200px)
   */
  forDesktopUp: "@media screen and (min-width: ".concat(breakpoints.forDesktopUp, "px)"),
  /**
   * @returns @media screen and (max-width: 1799px)
   */
  forDesktopDown: "@media screen and (max-width: ".concat(breakpoints.forDesktopDown, "px)"),
  /**
   * @returns @media screen and (max-width: 1800px)
   */
  forBigDesktopUp: "@media screen and (min-width: ".concat(breakpoints.forBigDesktopUp, "px)"),
  /**
   * @returns @media screen and (max-width: 2649px)
   */
  forUltraWideDesktopDown: "@media screen and (max-width: ".concat(breakpoints.forUltraWideDesktopDown, "px)"),
  /**
   * @returns @media screen and (max-width: 2650px)
   */
  forUltraWideDesktopUp: "@media screen and (min-width: ".concat(breakpoints.forUltraWideDesktopUp, "px)")
};

/**
 * Pick data attributes from props
 *
 * @param {object} props - Component props
 * @returns {object} - data-* attributes
 */
var pickDataAttributes = function pickDataAttributes(props) {
  return R.pickBy(function (val, key) {
    return R.startsWith('data-', key);
  }, props);
};

var _excluded = ["className", "id"];
/**
 * Pick allowed DOM attributes from props
 *
 * @param {object} props - Component props
 * @returns {object} - DOM attributes
 */
var pickDomAttributes = function pickDomAttributes(_ref) {
  var className = _ref.className,
    id = _ref.id,
    props = _objectWithoutProperties(_ref, _excluded);
  var dataAttrs = pickDataAttributes(props);
  return R.reject(R.isNil, _objectSpread2({
    className: className,
    id: id
  }, dataAttrs));
};

var BGEA_SOURCE = 'bgea_source';
var DEFAULT_SOURCE = 'BY000INTR';
var setSourceCookie = function setSourceCookie(formQueryString, superUrl, time) {
  var cookies = new Cookies();
  var dayLimit = 86400;
  // if timelimit is undefined then it sets time limit to 24hours or to the defined timelimit
  var timeLimit = !time ? dayLimit : time;
  if (!getSourceCookie()) {
    var _location, _location$host, _location2, _location2$host;
    var queryStringDict = getQueryStringDict(formQueryString);
    var sourceValue = DEFAULT_SOURCE;
    Object.entries(queryStringDict).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      if ((key === null || key === void 0 ? void 0 : key.toLocaleLowerCase()) === 'source') {
        sourceValue = value;
      }
    });
    cookies.set(BGEA_SOURCE, sourceValue, {
      maxAge: timeLimit,
      path: superUrl || '/',
      domain: (_location = location) !== null && _location !== void 0 && (_location$host = _location.host) !== null && _location$host !== void 0 && _location$host.includes('localhost') ? 'localhost' : '.billygraham.org',
      secure: !((_location2 = location) !== null && _location2 !== void 0 && (_location2$host = _location2.host) !== null && _location2$host !== void 0 && _location2$host.includes('localhost'))
    });
  }
  return getSourceCookie();
};

/**
 * Default props arg types to be used with a Storybook story.
 */
var defaultPropsArgTypes = {
  className: {
    description: 'CSS class applied to the component.',
    control: {
      disable: true
    },
    table: {
      category: 'Default Props',
      type: {
        summary: 'string'
      }
    }
  },
  data: {
    name: 'data-*',
    description: 'Data allow us to store extra information on standard, semantic HTML elements.',
    control: {
      disable: true
    },
    table: {
      category: 'Default Props',
      type: {
        summary: 'string'
      }
    }
  },
  id: {
    description: 'CSS id applied to the component.',
    control: {
      disable: true
    },
    table: {
      category: 'Default Props',
      type: {
        summary: 'string'
      }
    }
  }
};

export { defaultPropsArgTypes, getParam, getQueryStringDict, getSourceCookie, getSourceQueryString, isCookieEnabled, isLocalStorageAvailable, mediaQueries, pickDataAttributes, pickDomAttributes, setSourceCookie, truncateString };
